export function calcAge(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  if (Number.isNaN(d.getTime())) return null;
  return Math.floor((Date.now() - d.getTime()) / (365.25 * 86400000));
}

export function dobFromAgeYears(years) {
  const today = new Date();
  const birth = new Date(today);
  birth.setFullYear(today.getFullYear() - years);
  return birth.toISOString().split("T")[0];
}
